
// writes |count| 1's into |a|', starting at |bitIndex|. returns the new bitIndex.
export function write1s(a: Uint8Array, bitIndex: number, count: number = 1): number {
  // Math.floor(i/8) gives the byte index, and (i % 8) gives the offset within the byte to the desired bit
  // the '7 - ' is because we're little endian
  for (let i = 0; i < count; i++) {
    a[Math.floor((bitIndex+i)/8)] |= 1 << (7 - ((bitIndex+i) % 8));
    //a[Math.floor((bitIndex+i)/8)] &= ~(1 << (7 - (bitIndex+i) % 8)); // this would be for big-endian
  }
  return bitIndex + count;
}

